export const alertColors: { [key: string]: string } = {
  //Alarms
  ClockInvalid: '#fd7070',
  BatteryReplace: 'orange',
  ProgramMemoryError: '#abab0a',
  RamError: '#87c787',
  NvMemoryError: '#759edb',
  MeasurementSystemError: '#8484a7',
  WatchdogError: '#dfbac0',
  FraudAttempt: 'darkgoldenrod',
  TotalPowerFailure: '#c9c9c9',
  PowerResume: '#817373',
  VoltageMissingPhaseL1: '#00ffffbf',
  VoltageMissingPhaseL2: '#c58ecb',
  VoltageMissingPhaseL3: '#b1ffb1',
  VoltageNormalPhaseL1: 'teal',
  VoltageNormalPhaseL2: 'violet',
  VoltageNormalPhaseL3: '#ba5bff',
  MissingNeutral: 'gold',
  PhaseAsymmetry: '#7d7d7d',
  CurrentReversal: 'olivedrab',
  WrongPhaseSequence: '#fb4545',
  UnexpectedConsumption: '#6565ff',
  KeyExchanged: 'coral',
  BadVoltageQualityL1: 'lightblue',
  BadVoltageQualityL2: 'lightgreen',
  BadVoltageQualityL3: 'lightpink',
  ExternalAlert: 'khaki',
  LocalCommunicationAttempt: 'lavender',
  DisconnectReconnectFailure: 'peru',

  //Events
  GeneralData: '#817373',
  OnConnect: '#7d899b' ,
  OnAlarm: '#fb4545',
  OnPowerDown: '#ba5bff',
  ScheduledLoadProfile: 'darkgoldenrod',
  OnInstallation: 'lightgreen',
  ScheduledLoadProfile1:'#FAC8F2',
  ScheduledLoadProfile2: '#84D1FA',
  ScheduledLoadProfile3: '#EAFAC8',

  //Event logs
  EventLog1: '#c98a96',
  EventLog2: '#fd7070',
  EventLog3: '#9cc47a',
  EventLog4: '#c49a86',
  EventLog5: '#b48ad6',
  EventLog6: '#84D1FA'
};

export function getAlertColor(alertName: string): string {
  if (alertColors[alertName]) {
    return alertColors[alertName] || 'transparent';
  } else {
    const colorKeys = Object.keys(alertColors);
    const randomKey = colorKeys[Math.floor(Math.random() * colorKeys.length)];
    return alertColors[randomKey];
  }
}

export function getAssetTypeColor(assetType: string): string {
  return alertColors['GeneralData'];
}

export function getRegionColor(assetType: string): string {
  return alertColors['RamError'];
}
